import Button, { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import React from 'react';

export const orderStepsForwardGridId = 'OrderSummary.orderStepsForwardGrid';
const orderStepsForwardGridOptions: iDataGridDisplayOptions = {
    id: orderStepsForwardGridId,
    columnAutoWidth: true,
    showBorders: false,
    showColumnLines: false,
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            allowSorting: false,
        },
        {
            dataField: 'location',
            caption: 't~OrderForward:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            dataField: 'plannedStartDate',
            caption: 't~OrderForward:column.plannedStartDate',
            width: '200px',
            cellTemplate: 'OrderForwardPlannedStartDateColumn',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: 'type',
            caption: 't~OrderForward:column.type',
            width: '200px',
            cellTemplate: 'ReturnStepType',
            allowSorting: false,
        },
        {
            dataField: 'payload.carrierCount',
            caption: 't~OrderForward:column.carrierCount',
            width: '80px',
            dataType: 'number',
            allowSorting: false,
        },
    ],
};
propsStore.insert(orderStepsForwardGridOptions);

export const orderStepsReturnGridId = 'OrderSummary.orderStepsReturnGrid';
const orderStepsReturnGridOptions: iDataGridDisplayOptions = {
    id: orderStepsReturnGridId,
    columnAutoWidth: true,
    showBorders: false,
    showColumnLines: false,
    selection: {
        mode: 'single',
    },
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            allowSorting: false,
        },
        {
            dataField: 'location',
            caption: 't~OrderReturn:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            dataField: 'plannedStartDate',
            caption: 't~OrderForward:column.plannedStartDate',
            width: '200px',
            cellTemplate: 'OrderReturnPlannedStartDateColumn',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: 'type',
            caption: 't~OrderReturn:column.type',
            width: '200px',
            cellTemplate: 'ReturnStepType',
            allowSorting: false,
        },
        {
            dataField: 'payload.carrierCount',
            caption: 't~OrderReturn:column.carrierCount',
            width: '80px',
            dataType: 'number',
            allowSorting: false,
        },
    ],
};
propsStore.insert(orderStepsReturnGridOptions);
